{
  "ResourceRowGallery": {
    "failedToLoad": "Nie udało się załadować pinów",
    "empty": "Brak pinów",
    "addContactPins": "Dodaj piny"
  },
  "TransferResourceDialog": {
    "title": "Przenieś do przestrzeni roboczej",
    "description_one": "Przenieś {{name}} do innej przestrzeni roboczej.",
    "description_other": "Przenieś {{count}} zasobów do innej przestrzeni roboczej.",
    "fieldWorkspace": "Docelowa przestrzeń robocza",
    "success_one": "Zasób przeniesiony",
    "success_other": "Przeniesiono {{count}} zasobów"
  }
}
